import BaseService from './base.service';

const formatDateForBackend = (date) => {
  if (!date) return null;

  const [month, day, year] = date.split('-');

  return `${month}/${day}/${year}`;
};

class TechnologistService extends BaseService {
  async getTechnologistSummary(technologistId, startDate, endDate, timeGranularity = 'day') {
    let url = '/observations-reports/technologist-summary';
    const params = [];

    params.push(`technologistId=${technologistId}`);
    params.push(`timeGranularity=${timeGranularity}`);

    if (startDate) {
      params.push(`startDate=${formatDateForBackend(startDate)}`);
    }

    if (endDate) {
      params.push(`endDate=${formatDateForBackend(endDate)}`);
    }

    url = `${url}?${params.join('&')}`;
    return this.get(url);
  }

  async getCategoryStatistics(technologistId, startDate, endDate, filters = {}) {
    let url = '/observations-reports/category-statistics';
    const params = [];

    if (technologistId) {
      params.push(`technologistId=${technologistId}`);
    }

    if (startDate) {
      params.push(`startDate=${formatDateForBackend(startDate)}`);
    }

    if (endDate) {
      params.push(`endDate=${formatDateForBackend(endDate)}`);
    }

    if (filters.type) {
      params.push(`type=${filters.type}`);
    }

    if (filters.modality) {
      params.push(`modality=${filters.modality}`);
    }

    if (filters.facilityId) {
      params.push(`facilityId=${filters.facilityId}`);
    }

    if (filters.departmentId) {
      params.push(`departmentId=${filters.departmentId}`);
    }

    url = `${url}?${params.join('&')}`;
    return this.get(url);
  }

  async getTechnologistComparison(startDate, endDate) {
    let url = '/observations-reports/technologist-comparison';
    const params = [];

    if (startDate) {
      params.push(`startDate=${formatDateForBackend(startDate)}`);
    }

    if (endDate) {
      params.push(`endDate=${formatDateForBackend(endDate)}`);
    }

    if (params.length > 0) {
      url = `${url}?${params.join('&')}`;
    }

    return this.get(url);
  }
}

export default TechnologistService;
